
export const USER_ADDRESS_TYPE = 2;
export const USERID_ADDRESS_TYPE = 3;
export const GROUP_ADDRESS_TYPE = 6;
export const ATRAX_ADDRESS_TYPE = 9;

export const IMAGE_FILE_TYPE = 11;
export const TEXT_FILE_TYPE = 12;

export const KEYS_USERNAME = "@keys";